/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_2_TitleInputs */

const en_mk_how_2_title = /** @type {(inputs: Mk_How_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick divisions & agents`)
};

const id_mk_how_2_title = /** @type {(inputs: Mk_How_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih divisi & agen`)
};

/**
* | output |
* | --- |
* | "Pick divisions & agents" |
*
* @param {Mk_How_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_2_title = /** @type {((inputs?: Mk_How_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_2_title(inputs)
	return en_mk_how_2_title(inputs)
});